var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSocialFacebook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 21,
    viewBox: "0 0 10 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006b3f",
    fillRule: "evenodd",
    d: "M2.221 20.452h4.435V10.45h2.958l.392-3.446h-3.35L6.66 5.28c0-.898.092-1.38 1.476-1.38h1.849V.451H7.026c-3.554 0-4.805 1.672-4.805 4.483v2.07H.006v3.446h2.215v10z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSocialFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-social-facebook.176db7d08aee0fe993cb74df3edf92b4.svg";